import * as layout from '@/mixin/layoutInfo'

export default {
    methods: {
        /**
         * 与えられた条件を元にレイアウトIDに変換する
         * 
         * @param {String} runModeID - ランモードID
         * @param {String} layoutName - レイアウト名
         * @param {Array} groupIDArray - グループIDの配列
         * @return {Number} 特定したレイアウトIDを返す
         */
        convertLayoutID: function(runModeID, layoutName, groupIDArray) {

            // グループID無しになる値をあらかじめ変換
            var convertedArray = this.convertNothingGroupIDValue(groupIDArray);
            // レイアウト情報の一覧を取得
            var layoutInfoAry = layout.info.layoutInfo;
            // ランモードIDとレイアウト名でレイアウト情報絞り込み
            var foundLayoutInfoAry = this.filterByRunmodeIDAndLayoutName(layoutInfoAry, runModeID, layoutName);

            var layoutID = null;

            // レイアウト情報が一意だったら、レイアウトID確定
            if(foundLayoutInfoAry.length === 1) {
                layoutID = foundLayoutInfoAry[0].layoutID;
            } 
            // レイアウト情報が見つからない場合は、エラーとしてnullを返す
            else if (foundLayoutInfoAry.length === 0) {
                return null;
            }
            // ランモードIDとレイアウト名で一意にならなかった場合は、グループIDで検索する
            else {
                // 先に例外的なレイアウトIDに該当するかどうか確認
                layoutID = this.checkExceptionLayoutID(convertedArray);
                if(layoutID === null) {
                    layoutID = this.filterByGroupIDs(foundLayoutInfoAry, runModeID, layoutName, convertedArray);
                }
            }
            // 問題データ誤りによるレイアウトIDを変換
            layoutID = this.convertExceptionLayoutID(layoutID);
            
            return layoutID;
        },
        /**
         * グループID無しになる値を「-」に変換する
         * 
         * @param {Array} groupIDArray - グループIDの配列
         * @return {Array} 変換後の配列を返す
         */
        convertNothingGroupIDValue: function(groupIDArray) {
            for(var i=0; i<groupIDArray.length; i++) {
                if(groupIDArray[i] === "" || groupIDArray[i] === "0") {
                    groupIDArray.splice(i,1,"-");
                }
            }
            return groupIDArray;
        },
        /**
         * ランモードIDとレイアウト名からレイアウト情報を絞り込む
         * 
         * @param {Array} laouyInfoAry - 外部ファイルから読み込んだレイアウト情報の一覧
         * @param {String} runModeID - ランモードID
         * @param {String} layoutName - レイアウト名
         * @return {Array} - 該当したレイアウト情報の一覧を配列で返す
         */
        filterByRunmodeIDAndLayoutName: function(layoutInfoAry, runModeID, layoutName) {
            var foundLayoutInfoAry = [];

            // 一覧からランモードIDとレイアウト名が一致するレイアウト情報を検索
            layoutInfoAry.forEach(function(layoutInfo) {
                if ((layoutInfo.runModeID.indexOf(runModeID) >= 0) &&
                    (layoutInfo.layoutName.indexOf(layoutName) >= 0)) {
                        foundLayoutInfoAry.push(layoutInfo);
                    }
            });

            return foundLayoutInfoAry;
        },
        /**
         * グループIDが全て同じ値(「-」以外)であるかどうかを確認する
         * 
         * @param {Array} groupIDArray - グループIDの配列
         * @return {Boolean} true:全て同じ、flase:全て同じでない(または「-」)
         */
        checkedGroupIDAllSame: function(groupIDArray) {
            var isAllSame = false;
            var ary = [];
            for(var i=0; i<groupIDArray.length; i++) {
                if(ary.indexOf(groupIDArray[i]) === -1) {
                    ary.push(groupIDArray[i]);
                }
            }
            if(ary.length===1 && ary[0] != "-") {
                isAllSame = true;
            }
            return isAllSame;
        },
        /**
         * グループIDの配列からレイアウト情報を絞り込む
         * 
         * @param {Array} foundLayoutInfoAry - ランモードIDとレイアウト名から絞り込んだレイアウト情報の一覧
         * @param {String} runModeID - ランモードID
         * @param {String} layoutName - レイアウト名
         * @param {Array} groupIDArray - グループIDの配列
         * @return {Number} 絞り込んだレイアウトIDを返す 
         */
        filterByGroupIDs: function(foundLayoutInfoAry, runModeID, layoutName, groupIDArray) {

            var isAllSame = this.checkedGroupIDAllSame(groupIDArray);
            var layoutID = null;

            for (var i=0; i<foundLayoutInfoAry.length; i++) {
                // レイアウト情報を取得
                var layoutInfo = foundLayoutInfoAry[i];

                var allowedValue = true;

                // レイアウト情報中のグループIDが、直前の値からどのように変化したかによって、
                // 実際のxml内のグループIDで許容される値が決まる
                for(var j=1; j<layoutInfo.groupIDs.length; j++) {

                    // 段組み時レイアウトで2段目最初のactかつ、全ての値が同じでなく、実際のグループIDの値が直前と同じ値の場合、許容する
                    if((j == layoutInfo.secondRowActNum-1) &&
                        !(isAllSame) &&
                        (groupIDArray[j-1] === groupIDArray[j])) { 
                        continue;
                    }
                    
                    // 「-」→「-」、または「数字」→「-」なら実際のグループIDの値は「-」か直前と異なる値
                    if((layoutInfo.groupIDs[j-1] === "-" && layoutInfo.groupIDs[j] === "-") ||
                      (layoutInfo.groupIDs[j-1] != "-" && layoutInfo.groupIDs[j] === "-")) {
                        if(!(groupIDArray[j] === "-" || groupIDArray[j-1] != groupIDArray[j])) {
                            allowedValue = false;
                            break;
                        }
                    }

                    // 「-」→「数字」、または「数字」→「違う数字」なら、実際のグループIDの値は直前と異なる値
                    if((layoutInfo.groupIDs[j-1] === "-" && layoutInfo.groupIDs[j] != "-") ||
                      (layoutInfo.groupIDs[j-1] != "-" && (layoutInfo.groupIDs[j] != "-" && layoutInfo.groupIDs[j-1] != layoutInfo.groupIDs[j]))){
                        if(!(groupIDArray[j-1] != groupIDArray[j])) {
                            allowedValue = false;
                            break;
                        }
                    }

                    // 「数字」→「同じ数字」なら、実際のグループIDの値は直前と同じ値
                    if(layoutInfo.groupIDs[j-1] != "-" && (layoutInfo.groupIDs[j] != "-" && layoutInfo.groupIDs[j-1] === layoutInfo.groupIDs[j])) {
                        if(!((groupIDArray[j-1] === groupIDArray[j]) && (groupIDArray[j-1] != "-") && (groupIDArray[j] != "-"))) {
                            allowedValue = false;
                            break;
                        }
                    }
                }
                // 全groupIDのチェック終わった時点で、allewedValueがtrueなら、layoutIDが確定する
                if(allowedValue) {
                    layoutID = foundLayoutInfoAry[i].layoutID;
                    break;
                }
            }
            return layoutID;
        },
        /**
         * 上段と下段で同じグループになる、例外的なレイアウトIDであるかを確認する
         * 該当するのは、「122」、「307」、「327」
         * 
         * @param {Array} groupIDArray - グループIDの配列
         * @return {Number} 絞り込んだレイアウトIDを返す 
         */
        checkExceptionLayoutID: function(groupIDArray) {
            
            var layoutID = null;

            var groupIDArray122 = ["1", "1", "2", "2", "1", "2"];
            var groupIDArray307 = ["1", "2", "-", "2", "2"];
            var groupIDArray327 = ["-", "1", "-", "-", "-", "1", "-", "-"];

            if(groupIDArray.toString() == groupIDArray122.toString()) {
                layoutID = 122;
            } else if(groupIDArray.toString() == groupIDArray307.toString()) {
                layoutID = 307;
            } else if(groupIDArray.toString() == groupIDArray327.toString()) {
                layoutID = 327;
            }

            return layoutID;
        },
        /**
         * 問題データ誤りとなる、例外的なレイアウトIDを変換する
         * 該当するのは、「186」、「428」
         * 
         * @param {Number} layoutID - 変換前のレイアウトID
         * @return {Number} 変換後のレイアウトID
         */
        convertExceptionLayoutID: function(layoutID) {

            var convertedLayoutID;

            if(layoutID === 186) {
                convertedLayoutID = 172;
            } else if(layoutID === 428) {
                convertedLayoutID = 427;
            } else {
                convertedLayoutID = layoutID;
            }

            return convertedLayoutID;
        },       
    }
}



// WEBPACK FOOTER //
// ./src/mixin/layoutID.js